module.exports = __webpack_public_path__ + "static/img/bt.0c46cb7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/bt.png
// module id = ScN3
// module chunks = 1